/* Etiquetas multiidoma en inglés. */
export default {
  "paginationControls.summary": "{first} - {last} of {totalCount}",
};
